"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const camelize_1 = __importDefault(require("camelize"));
function camelToSnake(obj) {
    if (Array.isArray(obj)) {
        return obj.map(camelToSnake);
    }
    else if (obj !== null && typeof obj === 'object') {
        return Object.fromEntries(Object.entries(obj).map(([key, value]) => [
            key.replace(/([A-Z])/g, '_$1').toLowerCase(),
            camelToSnake(value),
        ]));
    }
    return obj;
}
// Dont camelToSnake the request/response of these endpoints
const endpointExceptions = ['manualPostFiles'];
function camelizeResponse(baseQuery) {
    const baseQueryWithCamelize = async (args, api, extraOptions = {}) => {
        if (!endpointExceptions.includes(api.endpoint)) {
            if (typeof args !== 'string' && args.body) {
                args = { ...args, body: camelToSnake(args.body) };
            }
        }
        const result = await baseQuery(args, api, extraOptions);
        if (result.data) {
            result.data = (0, camelize_1.default)(result.data);
        }
        return result;
    };
    return baseQueryWithCamelize;
}
exports.default = camelizeResponse;
